export default __webpack_public_path__ + "static/media/less.3374ba32.svg";